import FetchClient from "@dpdgroupuk/fetch-client";

const apiClient = new FetchClient({
  mode: "cors",
  baseUrl: `${process.env.REACT_APP_IW_APIS_URL}/v1`,
});

export default apiClient;
